import { render, staticRenderFns } from "./Price1920.vue?vue&type=template&id=04dcd3d9&scoped=true"
import script from "./Price1920.vue?vue&type=script&lang=js"
export * from "./Price1920.vue?vue&type=script&lang=js"
import style0 from "./Price1920.vue?vue&type=style&index=0&id=04dcd3d9&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dcd3d9",
  null
  
)

export default component.exports